import React from "react"
import { debounceStorage } from "..";
import { ui } from "../interfaces/interfaces"
import { useAppSelector } from "../store/hooks";
import { calculatePayments } from "../components/Shared/BillingMethodTab/helpers";
import { RightioWBSAPIModelsUdtUdtOfferParamsV3 } from "@utils/apis/wbs/model";

const recalculatePayments = async () => {
    const offer: RightioWBSAPIModelsUdtUdtOfferParamsV3 | undefined =
        ui.CarePlanPlanDetailsOfferOfferType?.serviceAgreementOfferId !== undefined && ui.CarePlanPlanDetailsOfferOfferReason?.serviceAgreementOfferAllocationReasonId !== undefined
            ? {
                serviceAgreementOfferId: ui.CarePlanPlanDetailsOfferOfferType?.serviceAgreementOfferId,
                serviceAgreementOfferAllocationReasonId: ui.CarePlanPlanDetailsOfferOfferReason?.serviceAgreementOfferAllocationReasonId,
                allocationContractPeriod: 1,
                allocationOrder: 1,
                serviceAgreementCampaignCodeId: 0,
                serviceAgreementDurationId: ui.CarePlanPlanDetailsPlanOptionsDuration?.serviceAgreementDurationId,
            } : undefined

    const result = await calculatePayments(ui.CarePlanPlanDetailsPlanOptionsPlanType!, ui.CarePlanPlanDetailsPlanOptionsBillingFrequency!, ui.CarePlanPlanDetailsPlanOptionsDuration!, ui.CarePlanPlanDetailsPlanOptionsExcess!, offer);

    ui.CarePlanSummary = result;
}

const resetSummary = () => {
    ui.CarePlanSummary = ""
}

const useRecalculatePayments = () => {
    // monitor for changes below VALUES
    const serviceAgreementPolicyPlanType = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsPlanType) //object
    const serviceAgreementBillingPaymentFrequencies = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsBillingFrequency) //object
    const serviceAgreementBillingDurations = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsDuration) //object
    const serviceAgreementBillingExcesses = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsPlanOptionsExcess) //object
    const serviceAgreementPolicyOfferType = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsOfferOfferType) //object
    const serviceAgreementPolicyOfferReason = useAppSelector(({ ui }) => ui.CarePlanPlanDetailsOfferOfferReason) //object

    // use memo to prevent unnecessary re-renders
    const dependencies = React.useMemo(() => ({
        planType: serviceAgreementPolicyPlanType,
        paymentFrequencies: serviceAgreementBillingPaymentFrequencies,
        durations: serviceAgreementBillingDurations,
        excesses: serviceAgreementBillingExcesses,
        offerType: serviceAgreementPolicyOfferType,
        offerReason: serviceAgreementPolicyOfferReason
    }),
        [serviceAgreementPolicyPlanType, serviceAgreementBillingPaymentFrequencies, serviceAgreementBillingDurations, serviceAgreementBillingExcesses, serviceAgreementPolicyOfferType, serviceAgreementPolicyOfferReason])

    // call effect if any of VALUES change
    React.useEffect(() => {
        // recalculate only if all values are set
        if (dependencies.planType?.serviceAgreementTypeId && dependencies.paymentFrequencies?.serviceAgreementBillingFrequencyId && dependencies.durations?.serviceAgreementDurationId && dependencies.excesses?.serviceAgreementExcessId !== undefined && dependencies.offerType?.serviceAgreementOfferId === undefined) {
            debounceStorage.addOrExecute({ name: "RecalculatePayments", delay: 100, callback: recalculatePayments })
        }
        else if (dependencies.planType?.serviceAgreementTypeId && dependencies.paymentFrequencies?.serviceAgreementBillingFrequencyId && dependencies.durations?.serviceAgreementDurationId && dependencies.excesses?.serviceAgreementExcessId !== undefined && dependencies.offerType?.serviceAgreementOfferId !== undefined && dependencies.offerReason?.serviceAgreementOfferAllocationReasonId !== undefined) {
            debounceStorage.addOrExecute({ name: "RecalculatePayments", delay: 100, callback: recalculatePayments })
        }
        else {
            resetSummary()
        }
    }, [dependencies])
}

export default useRecalculatePayments